import type { SummaryRow } from "@/types/types";
import { formatNumber } from "devextreme/localization";

type Props = {
  data: SummaryRow;
};

export default function SummaryRow({ data }: Props) {
  const isDebt = data?.name?.includes("Debts");

  return (
    <>
      <div className="grid grid-cols-3 gap-x-4">
        <div className="relative h-[1px] bg-neutral-500"></div>
        <div className="relative h-[1px] bg-neutral-500"></div>
        <div className="relative h-[1px] bg-neutral-500"></div>
      </div>
      <div className="grid grid-cols-3 gap-x-4 py-4">
        <div
          className={`${isDebt ? "text-danger" : "break-words text-neutral-100"} px-4 font-medium`}
        >
          {data?.name}
        </div>
        <div
          className={`${
            isDebt ? "text-danger" : "text-neutral-100"
          } relative pl-1 after:absolute after:-top-2 after:left-0 after:h-[calc(100%+1rem)] after:w-[1px] after:-translate-x-[0.625rem] after:bg-neutral-500`}
        >
          {(data?.currentValue ?? 0) < 0 ? "-" : ""}
          {data?.currentValue
            ? (formatNumber(data?.currentValue ?? 0, "$ #,##0") ?? "")
                .replaceAll("(", "")
                .replaceAll(")", "")
            : null}
        </div>
        <div className="relative pl-1 text-neutral-100 after:absolute after:-top-2 after:left-0 after:h-[calc(100%+1rem)] after:w-[1px] after:-translate-x-[0.625rem] after:bg-neutral-500">
          {(data?.grossEstateValue ?? 0) < 0 ? "-" : ""}
          {data?.grossEstateValue
            ? formatNumber(data?.grossEstateValue ?? 0, "$ #,##0")
                ?.replaceAll("(", "")
                .replaceAll(")", "")
            : ""}
        </div>
      </div>
    </>
  );
}
